import { Tabs } from "antd";
import { useContext, useState, useRef, forwardRef } from "react";
import { InitContext } from "../../contexts/init";
import { TempWorkContext } from "../../contexts/tmpwork";
import { TaskList } from "./TaskList";
import { Loading } from "../ui/Loading";
import { Tab } from "../../contexts/overview";

import { staticText } from "../../utils/staticText";
import { ReactComponent as NoData } from "../../images/assign/no-data.svg";

export const WokList = forwardRef(
  (props, ref: React.MutableRefObject<HTMLDivElement>) => {
    const { data: InitData, dispatch: InitDispatch } = useContext(InitContext);
    const { dataLoading } = InitData;
    const { data, dispatch } = useContext(TempWorkContext);
    const { taskLists, tab } = data;
    const { TabPane } = Tabs;
    const [tabs] = useState(staticText.tabs);
    const { overview } = staticText;

    function callback(key: string) {
      dispatch({
        type: "setState",
        payload: {
          tab: Tab[key],
          reload: true,
        },
      });
      InitDispatch({
        type: "setState",
        payload: { dataLoading: { value: true, type: "search" } },
      });
    }

    return (
      <div ref={ref}>
        <Tabs activeKey={Tab[tab].toString()} onChange={callback}>
          {tabs.map((ele, i) => (
            <TabPane tab={ele} key={(i + 1).toString()}>
              {dataLoading.value ? (
                <Loading />
              ) : (
                Tab[tab] === i + 1 &&
                (taskLists.length > 0 ? (
                  taskLists.map((taskList, i2) => {
                    return <TaskList {...taskList} index={i2} />;
                  })
                ) : (
                  <div className="no-data">
                    <NoData />
                    <h3>
                      {overview.wok.nowork[tab ? tab : "null"]}
                    </h3>
                  </div>
                ))
              )}
            </TabPane>
          ))}
        </Tabs>
      </div>
    );
  }
);
